export default abstract class IWorkerPostMessage {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public abstract postMessage(data: any): any;
  public abstract isWaitingForPivotChunk(): boolean;
  public abstract setWaitingForPivotChunk(value: boolean): void;
}
